import axios from "axios";
import { URLAPI } from "../../Setting";
import { errorService } from "../Error/ErrorService";
import { Delta, Flux, Message, TypeMessage } from "../../Models/Message/MessageModels";
import { MessageService } from "./MessageService";
import { AbonnementService } from "../Abonnement/AbonnementService";
import { Abonnement } from '../../Models/Abonnement/AbonnementModels';
import { SousGroupeService } from "../Magasin/SousGroupeService";

export function FluxService(){

    return{
        async getFluxes(token:string){
            let fluxes:Flux[]=[];
            try {
                const response = await axios.get(`${URLAPI+'fluxes'}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type":"application/ld+json"
                    },
                });
                const data = response.data['hydra:member'];
                if(data.length>0){
                    for(const element of data){
                        const [abonnement] = await Promise.all([
                            AbonnementService().getAbonnementFromUrlToPromiseToFlux(element['abonnement'], token)
                        ]);
                        let flux:Flux = {
                            id:element['id'],
                            '@id':element['@id'],
                            nom:element['nom'],
                            // messages:element['messages'].map((mess: any)=>{return {"@id":mess}}),
                            messages: element['messages'].map((mess: any)=> typeof mess==='string' ? {"@id":mess} : mess),
                            abonnement:abonnement,
                            deltas:element['deltas'],
                            dateDeconnexion:element['dateDeconnexion'],
                            compteServeur:element['compteServeur'],
                        };
                        // if(element['messages'].length>0){
                        //     const [messages] = await Promise.all([
                        //         MessageService().getMessagesFromUrlsToAnythingWithoutLanguages(element['messages'], token)
                        //     ]);
                        //     flux.messages = messages;
                        // }
                        fluxes.push(flux);
                    }
                }

            } catch (error) {
                errorService().handleError("Erreur lors de l'obtention d'un flux", error)
                return [];
            }
            return fluxes;
        },

        async getFluxesUserAbonnements(abonnements:Abonnement[], token:string){
            let fluxes:Flux[]=[];
            try {
                const response = await axios.get(`${URLAPI+'fluxes'}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type":"application/ld+json"
                    },
                });
                const data = response.data['hydra:member'];
                if(data.length>0){
                    for(const element of data){
                        let flux:Flux = {
                            id:element['id'],
                            '@id':element['@id'],
                            nom:element['nom'],
                            messages: element['messages'].map((mess: any)=> typeof mess==='string' ? {"@id":mess} : mess),
                            abonnement:abonnements.find(abo=>abo["@id"]===element['abonnement']["@id"]),
                            deltas:element['deltas'],
                            dateDeconnexion:element['dateDeconnexion'],
                            compteServeur:element['compteServeur'],
                        };
                        fluxes.push(flux);
                    }
                }

            } catch (error) {
                errorService().handleError("Erreur lors de l'obtention d'un flux", error)
                return [];
            }
            return fluxes;
        },

        async getFluxesLight(token:string){
            let fluxes:Flux[]=[];
            try {
                const response = await axios.get(`${URLAPI+'fluxes'}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type":"application/ld+json"
                    },
                });
                const data = response.data['hydra:member'];
                if(data.length>0){
                    for(const element of data){
                        let flux:Flux = {
                            id:element['id'],
                            '@id':element['@id'],
                            nom:element['nom'],
                            // messages:element['messages'],
                            messages: element['messages'].map((mess: any)=> typeof mess==='string' ? {"@id":mess} : mess),
                            abonnement:element['abonnement'],
                            deltas:element['deltas'],
                            dateDeconnexion:element['dateDeconnexion'],
                            compteServeur:element['compteServeur'],
                        };
                        
                        fluxes.push(flux);
                    }
                }

            } catch (error) {
                errorService().handleError("Erreur lors de l'obtention d'un flux", error)
                return [];
            }
            return fluxes;
        },

        async getFluxesStatistiquesAdmin(token:string){
            let fluxes:Flux[]=[];
            try {
                const response = await axios.get(`${URLAPI+'fluxes'}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type":"application/ld+json"
                    },
                });
                const data = response.data['hydra:member'];
                if(data.length>0){
                    for(const element of data){
                        let flux:Flux = {
                            id:element['id'],
                            '@id':element['@id'],
                            nom:element['nom'],
                            messages:element['messages'],
                            abonnement:element['abonnement'],
                            deltas:element['deltas'],
                            dateDeconnexion:element['dateDeconnexion'],
                            compteServeur:element['compteServeur'],
                        };
                        
                        fluxes.push(flux);
                    }
                }

                const centrales = await SousGroupeService().getSousGroupesForAdmin(token);
                for(const flux of fluxes){
                    const centraleMag = centrales.find(cent=>cent.magasins?.find(magCent=>flux.abonnement && flux.abonnement.magasin && magCent.id===flux.abonnement?.magasin.id))
                    if(centraleMag && flux.abonnement && flux.abonnement.magasin){
                        flux.abonnement.magasin.sousGroupes = [];
                        flux.abonnement.magasin.sousGroupes.push(centraleMag);
                    }
                }

            } catch (error) {
                errorService().handleError("Erreur lors de l'obtention d'un flux", error)
                return [];
            }
            return fluxes;
        },

        
        async getFluxesCampagnes(token:string){
            let fluxes:Flux[]=[];
            try {
                const response = await axios.get(`${URLAPI+'fluxes'}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type":"application/ld+json"
                    },
                });
                const data = response.data['hydra:member'];
                if(data.length>0){
                    for(const element of data){
                        const [abonnement] = await Promise.all([
                            AbonnementService().getAbonnementFromUrlToPromiseToFlux(element['abonnement'], token)
                        ]);
                        let flux:Flux = {
                            id:element['id'],
                            nom:element['nom'],
                            messages:element['messages'].map((mess: any)=>{return {"@id":mess}}),
                            abonnement:abonnement,
                            deltas:element['deltas'],
                            dateDeconnexion:element['dateDeconnexion'],
                            compteServeur:element['compteServeur'],
                        };
                        // if(element['messages'].length>0){
                        //     const [messages] = await Promise.all([
                        //         MessageService().getMessagesFromUrlsToAnythingWithoutLanguages(element['messages'], token)
                        //     ]);
                        //     flux.messages = messages;
                        // }
                        fluxes.push(flux);
                    }
                }
                

            } catch (error) {
                errorService().handleError("Erreur lors de l'obtention d'un flux", error)
                return [];
            }
            return fluxes;
        },

        async getFlux(idFlux:number, token:string){
            let flux:Flux = {
                id:0,
                nom:'',
                messages:[],
                deltas:[],
                dateDeconnexion:new Date(),
                compteServeur:'',
            };
            try {
                const response = await axios.get(`${URLAPI+'flux/'+idFlux}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type":"application/ld+json"
                    },
                });
                const data = response.data['hydra:member'];
                flux = {
                    id:data[0]['id'],
                    nom:data[0]['nom'],
                    messages:data[0]['messages'],
                    deltas:data[0]['deltas'],
                    dateDeconnexion:data[0]['dateDeconnexion'],
                    compteServeur:data[0]['compteServeur'],
                };
                if(data[0]['messages'].length>0){
                    const [messages] = await Promise.all([
                        MessageService().getMessagesFromUrlsToAnythingWithoutLanguages(data[0]['messages'], token)
                    ]);
                    flux.messages = messages;
                }
                
                return {data:flux, status: response.status};

            } catch (error) {
                errorService().handleError("Erreur lors de l'obtention d'un flux", error)
                return {data:flux, status: 400};
            }
        },

        async getFluxAvecMessage(idFlux:number, token:string){
            let flux:Flux = {
                id:0,
                nom:'',
                messages:[],
                deltas:[],
                dateDeconnexion:new Date(),
                compteServeur:'',
            };
            try {
                const response = await axios.get(`${URLAPI+'fluxMessages/'+idFlux}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type":"application/ld+json"
                    },
                });
                const data = response.data['hydra:member'];
                const [abonnement] = await Promise.all([
                    AbonnementService().getAbonnementFromUrlToPromiseToFlux(data[0]['abonnement']['@id'], token)
                ]);
                flux = {
                    id:data[0]['id'],
                    nom:data[0]['nom'],
                    messages:data[0]['messages'],
                    deltas:data[0]['deltas'],
                    abonnement:abonnement,
                    dateDeconnexion:data[0]['dateDeconnexion'],
                    compteServeur:data[0]['compteServeur'],
                };
                return {data:flux, status: response.status};

            } catch (error) {
                errorService().handleError("Erreur lors de l'obtention d'un flux", error)
                return {data:flux, status: 400};
            }
        },

        async postFluxes(nbFlux:number, idAbonnement:number, nomMagasin:string, typeMagasin:string, compteServeur:string, token:string, dernierNumeroFlux?:number){
            let status = 400;
            for(let i=dernierNumeroFlux ?? 1;i<=nbFlux;i++){
                try {
                    const postFluxObjet = {
                        "nom": 'Flux '+(i)+' '+typeMagasin+' '+nomMagasin.toUpperCase(),
                        "abonnement": idAbonnement,
                        'compteServeur':compteServeur.length>0 ? compteServeur : undefined
                    };

                    const reponsePOSTFlux = await axios.post(
                        `${URLAPI+'flux'}`,
                        postFluxObjet,
                        {
                            headers: {
                                Authorization: `Bearer ${token}`,
                                'Content-Type': 'application/ld+json',
                            },
                        }
                    );

                    status = reponsePOSTFlux.status

                } catch (error) {
                    errorService().handleError("Erreur lors de l'ajout d'un flux", error)
                    return 400;
                }
            }
            return status;
        },

        async postFluxAdminMagasin(nomFlux:string, idAbonnement:number, compteServeur:string, token:string){
            let status = 400;
            try {
                const postFluxObjet = {
                    "nom": nomFlux,
                    "abonnement": idAbonnement,
                    'compteServeur':!/^\s*$/.test(compteServeur) ? compteServeur : undefined,
                    "messages":[]
                };

                const reponsePOSTFlux = await axios.post(
                    `${URLAPI+'flux'}`,
                    postFluxObjet,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            'Content-Type': 'application/ld+json',
                        },
                    }
                );

                status = reponsePOSTFlux.status

            } catch (error) {
                errorService().handleError("Erreur lors de l'ajout d'un flux", error)
                return 400;
            }
            return status;
        },

        async patchFluxAVide(idFlux:number, token:string){
            try {
                const patchFluxObjet = {
                    "messages": [],
                };

                const reponsePOSTFlux = await axios.patch(
                    `${URLAPI+'flux/'+idFlux}`,
                    patchFluxObjet,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            'Content-Type': 'application/ld+json',
                        },
                    }
                );

                return reponsePOSTFlux.status;

            } catch (error) {
                errorService().handleError("Erreur lors de la mis à jour d'un flux", error)
                return 400;
            }
        },



 
        async patchFluxMessagesAvecType(idFlux:number, messages:Message[], typeMessage:TypeMessage, token:string,activation:boolean){
            try {
                const fluxEdite = await this.getFluxAvecMessage(idFlux, token);
                if(fluxEdite && fluxEdite.data.messages.length>0){
                    // concatenationMessages = fluxEdite.messages;
                    let messageFinaux:Message[]=[]
                    for(let message of fluxEdite.data.messages){
                        // message.id = Number(extractNumeroFromUrl(message["@id"]));
                        

                        // message.id = Number(extractNumeroFromUrl(message["@id"]));
                        if(activation){
                            if(messages.find(mess=>mess.id===message.id) && (message.categorieMessage?.typeMessage?.id===typeMessage.id))continue;
                            messages.push(message);


                        }
                        else{
                            if(!messages.find(mess=>mess.id===message.id) && (message.categorieMessage?.typeMessage?.id===typeMessage.id))continue
                            messageFinaux.push(message)

                        }
                    
                        
                    }
                    if(activation){
                        messageFinaux=messages
                    }
                    const statusAVide =await this.patchFluxAVide(idFlux, token);
                    if(statusAVide===200){
                        const patchFluxObjet = {
                            "messages": messageFinaux.map(mess=>mess.id),
                        };

                        const reponsePOSTFlux = await axios.patch(
                            `${URLAPI+'flux/'+idFlux}`,
                            patchFluxObjet,
                            {
                                headers: {
                                    Authorization: `Bearer ${token}`,
                                    'Content-Type': 'application/ld+json',
                                },
                            }
                        );

                        return reponsePOSTFlux.status
                    }
                }
                const patchFluxObjet = {
                    "messages": messages.map(mess=>mess.id),
                };

                const reponsePOSTFlux = await axios.patch(
                    `${URLAPI+'flux/'+idFlux}`,
                    patchFluxObjet,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            'Content-Type': 'application/ld+json',
                        },
                    }
                );
                return reponsePOSTFlux.status
                // return 200;
            } catch (error) {
                errorService().handleError("Erreur lors de la mis à jour d'un flux", error)
                return 400;
            }
        },
/*
        async patchFluxSynchronisationType(idFlux:number, messagesAGarder:Message[], typeMessage:TypeMessage, token:string){
            try {
                const fluxEdite = await axios.get(`${URLAPI+'flux/'+idFlux}`, {
                    headers:{ Authorization:`Bearer ${token}`, "Content-Type":"application/ld+json" },
                });

                const idsAGarder = messagesAGarder.map(mess=>mess.id);
                const idsActuels:number[] = fluxEdite.data.messages.map((mess:any)=>mess.id);
                const idsFinaux:number[] = [];

                for(const message of fluxEdite.data.messages){
                    const dansLePerimetre = message.categorieMessage?.typeMessage?.id === typeMessage.id;
                    // hors perimetre : on conserve sans y toucher
                    if(!dansLePerimetre){ idsFinaux.push(message.id); continue; }
                    // dans le perimetre : conserve uniquement si toujours selectionne
                    if(idsAGarder.includes(message.id)) idsFinaux.push(message.id);
                }
                // ajout des messages selectionnes qui n'etaient pas encore dans le flux
                for(const id of idsAGarder){ if(!idsFinaux.includes(id)) idsFinaux.push(id); }

                // rien a changer : on evite le vidage, qui n'est pas atomique
                if(idsActuels.length===idsFinaux.length && idsActuels.every((id:number)=>idsFinaux.includes(id))) return 200;

                const statusAVide = await this.patchFluxAVide(idFlux, token);
                if(statusAVide!==200) return 400;

                const reponse = await axios.patch(
                    `${URLAPI+'flux/'+idFlux}`,
                    { "messages": idsFinaux },
                    { headers:{ Authorization:`Bearer ${token}`, 'Content-Type':'application/ld+json' } }
                );
                return reponse.status;
            } catch (error) {
                errorService().handleError("Erreur lors de la synchronisation des messages du flux", error);
                return 400;
            }
        },
*/
        async patchFluxSynchronisationType(idFlux:number, messagesAGarder:Message[], typeMessage:TypeMessage, token:string){
            try {
                // meme source que patchFluxMessagesAvecType : le flux/{id} brut ne serialise
                // pas les messages
                const fluxEdite = await this.getFluxAvecMessage(idFlux, token);
                // console.log('MESSAGES DU FLUX =', fluxEdite.data.messages);
                // un echec renvoie un flux vide : sans ce test, on viderait le flux de tous
                if(!fluxEdite || fluxEdite.status!==200 || !fluxEdite.data || !Array.isArray(fluxEdite.data.messages)){
                    errorService().handleError("Messages du flux non recuperables", new Error('Flux non charge'));
                    return 400;
                }

                const idsAGarder = messagesAGarder.map(mess=>mess.id);
                const idsActuels:number[] = fluxEdite.data.messages.map((mess:any)=>mess.id);
                const idsFinaux:number[] = [];

                for(const message of fluxEdite.data.messages){
                    const dansLePerimetre = message.categorieMessage?.typeMessage?.id === typeMessage.id;
                    // hors perimetre : on conserve sans y toucher
                    if(!dansLePerimetre){ idsFinaux.push(message.id); continue; }
                    // dans le perimetre : conserve uniquement si toujours selectionne
                    if(idsAGarder.includes(message.id)) idsFinaux.push(message.id);
                }
                // ajout des messages selectionnes qui n'etaient pas encore dans le flux
                for(const id of idsAGarder){ if(!idsFinaux.includes(id)) idsFinaux.push(id); }

                // rien a changer : on evite le vidage, qui n'est pas atomique
                if(idsActuels.length===idsFinaux.length && idsActuels.every((id:number)=>idsFinaux.includes(id))) return 200;

                const statusAVide = await this.patchFluxAVide(idFlux, token);
                if(statusAVide!==200) return 400;

                const reponse = await axios.patch(
                    `${URLAPI+'flux/'+idFlux}`,
                    { "messages": idsFinaux },
                    { headers:{ Authorization:`Bearer ${token}`, 'Content-Type':'application/ld+json' } }
                );
                return reponse.status;
            } catch (error) {
                errorService().handleError("Erreur lors de la synchronisation des messages du flux", error);
                return 400;
            }
        },

        async patchFluxMessages(idFlux:number, messages:Message[], token:string){
            try {
                const patchFluxObjet = {
                    "messages": messages.map(mess=>mess.id),
                };

                const reponsePOSTFlux = await axios.patch(
                    `${URLAPI+'flux/'+idFlux}`,
                    patchFluxObjet,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            'Content-Type': 'application/ld+json',
                        },
                    }
                );

                return reponsePOSTFlux.status
                // return 200;
            } catch (error) {
                errorService().handleError("Erreur lors de la mis à jour d'un flux", error)
                return 400;
            }
        },

        async patchFluxAdminMagasin(idFlux:number, nomFlux:string, idAbo:number, compteServeur:string, token:string){
            try {
                const patchFluxObjet = {
                    "nom":nomFlux,
                    "compteServeur": !/^\s*$/.test(compteServeur) ? compteServeur : undefined,
                    "abonnement":idAbo
                };

                const reponsePOSTFlux = await axios.patch(
                    `${URLAPI+'flux/'+idFlux}`,
                    patchFluxObjet,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            'Content-Type': 'application/ld+json',
                        },
                    }
                );

                return reponsePOSTFlux.status

            } catch (error) {
                errorService().handleError("Erreur lors de la mis à jour d'un flux", error)
                return 400;
            }
        },

        async deleteFlux(idFlux:number, token:string){
            try {
                const deleteFlux = await axios.delete(
                    `${URLAPI}flux/${idFlux}`,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    }
                );
                return deleteFlux.status
            } catch (error) {
                errorService().handleError('Erreur suppression flux', error)
                return 400;
            }
        },

        async ajouterMessageAuFlux(idFlux:number, idMessage:number, token:string){
            try {
                const reponse = await axios.post(
                    `${URLAPI+'flux/'+idFlux+'/message/'+idMessage}`,
                    {},
                    { headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/ld+json' } }
                );
                return reponse.status;   // 201 en succes (idempotent)
            } catch (error) {
                errorService().handleError("Erreur ajout message au flux", error);
                return 400;
            }
        },

        async retirerMessageDuFlux(idFlux:number, idMessage:number, token:string){
            try {
                const reponse = await axios.delete(
                    `${URLAPI+'flux/'+idFlux+'/message/'+idMessage}`,
                    { headers: { Authorization: `Bearer ${token}` } }
                );
                return reponse.status;   // 204 en succes (idempotent)
            } catch (error) {
                errorService().handleError("Erreur retrait message du flux", error);
                return 400;
            }
        },

    }
}
